<form
  class="form-group"
  [formGroup]="formGroup"
  [ngClass]="{
    error:
      formGroup.controls[formControlName].touched &&
      !formGroup.controls[formControlName].valid
  }"
  >
  @if (label) {
    <label [attr.for]="id">{{ label }} @if (required) {
      <span> *</span>
    }</label>
  }
  <div class="input-frame">
    @if (!textarea) {
      <input
        [id]="id"
        [formControlName]="formControlName"
        [placeholder]="placeholder"
      [mask]="
        type === 'phone'
          ? phoneMask
          : type === 'zip'
          ? zipMask
          : (type === 'counter' || type === 'number')
          ? counterMask
          : null
      "
      [type]="
      type === 'phone'
        ? 'tel'
        : (type === 'zip' || type === 'counter' || type === 'number')
        ? 'number'
        : type === 'email'
        ? 'email'
        : 'text'
      "
        [allowNegativeNumbers]="false"
        [ngClass]="{ 'centered': inputCentered }"
        />
    }
    @if (textarea) {
      <textarea
        [name]="label"
        [placeholder]="placeholder"
        [id]="id"
        [formControlName]="formControlName"
        row="4"
        [ngClass]="{'small': small}"
      ></textarea>
    }
    @if (showIcons) {
      <div
        class="icon-wrapper"
        [ngClass]="{ 'textarea-icon': textarea, 'small': small }"
        >
        @if (
          (formGroup.controls[formControlName].value?.trim() === '' &&
          !formGroup.controls[formControlName].touched) ||
          (formGroup.controls[formControlName].value?.trim() === '' && formGroup.controls[formControlName].touched && !formGroup.controls[formControlName].errors)
          ) {
          <img
            src="/assets/icons/cross-circle.svg"
            alt="No Value"
            class="empty"
            />
        }
        @if (
          formGroup.controls[formControlName].touched &&
          !formGroup.controls[formControlName].valid
          ) {
          <img
            src="/assets/icons/alert-circle.svg"
            alt="Invalid Value"
            class="invalid"
            />
        }
        @if (
          formGroup.controls[formControlName].value?.trim() !== '' &&
          formGroup.controls[formControlName].valid
          ) {
          <img
            src="/assets/icons/check-circle.svg"
            alt="Valid Value"
            class="valid"
            />
        }
      </div>
    }
  </div>
  <div class="error-msg" [ngClass]="{'counter-error': type === 'counter'}">
    @if (
      formGroup.controls[formControlName].invalid &&
      formGroup.controls[formControlName].touched
      ) {
      <div
        >
        @if (formGroup.controls[formControlName].errors?.['required']) {
          <span>{{
            ERROR_MESSAGES.FIELD_REQUIRED
          }}</span>
        }
        @if (formGroup.controls[formControlName].errors?.['maxlength']) {
          <span
            >Text length should be from 1 to
            {{
            formGroup.controls[formControlName].errors['maxlength'].requiredLength
            }}
            symbols.</span
            >
          }
          @if (type === 'phone' && formGroup.controls[formControlName].errors?.['mask']) {
            <span
              >{{ ERROR_MESSAGES.INVALID_PHONE }}</span
              >
            }
            @if (type === 'phone' && formGroup.controls[formControlName].errors?.['forbiddenPhone']) {
              <span
                >{{ ERROR_MESSAGES.FORBIDDEN_PHONE }}</span
                >
              }
              @if (type === 'email' && formGroup.controls[formControlName].errors?.['pattern']) {
                <span
                  >{{ ERROR_MESSAGES.INVALID_EMAIL }}</span
                  >
                }
                @if (type === 'text' && formGroup.controls[formControlName].errors?.['pattern']) {
                  <span
                    >{{ ERROR_MESSAGES.INVALID_CHARACTERS }}</span
                    >
                  }
                  @if (type === 'zip' && formGroup.controls[formControlName].errors?.['mask']) {
                    <span
                      >{{ ERROR_MESSAGES.INVALID_ZIPCODE }}</span
                      >
                    }
                    @if (type === 'counter' && formGroup.controls[formControlName].errors?.['min']) {
                      <span
                        >{{ errorMessages['min'] }}</span
                        >
                      }
                      @if (type === 'counter' && formGroup.controls[formControlName].errors?.['max']) {
                        <span
                          class="composite-msg"
                          >{{ errorMessages['max'] }}</span
                          >
                        }
                      </div>
                    }
                  </div>
                  @if (counter) {
                    <span
                      class="counter"
                      [ngClass]="{ 'textarea-counter': textarea }"
                      >
                      {{ formGroup.get(formControlName)?.value?.length || 0 }}/{{ counter }}
                    </span>
                  }
                </form>
